import React from 'react';

const Features = (props) => {
    return (
        <div className="aboutus">
            <div className="heading">About Us</div>
            <p >
                KJSCE Connect is developed by <strong>Vedant Nagani</strong> and <strong>Huzaifa Khilawala</strong>. We are also the students of KJSCE of branch Information Technology.
                This website was developed by us under the supervision of our seniors from IT and the HOD of IT Department
            </p>
        </div>
    )
}
export default Features;